import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav } from 'react-bootstrap';
import { RiShoppingBagFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { animated } from 'react-spring';
import { useCartStore } from 'stores';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// own components
import MyAccount from 'components/navbar/MyAccount';
import MenuItems from 'components/navbar/MenuItems';
import LogoComponent from 'components/navbar/LogoComponent';
import SearchBarMenu from '../SearchBarMenu';


const NavbarCollapse = ({
  isDesktop,
  isSticky,
  secondaryImage,
  blogCategories,
  showMiniSearchBar,
  counterAnimProps,
  closeSession,
  setShowMiniSearchBar,
  activeKey }) => {
  const { countItems } = useCartStore();
  const { libraryPath } = useAssignedLibrary();

  return (
    <Navbar.Collapse
      id="basic-navbar-nav"
      className="header-mobile-desktop-nav px-0 pb-0 container-fluid container container-responsive mainDiv"
      data-testid='Navbar Desktop'
    >
      <Nav
        className={`mx-auto navbar-left ${isDesktop ? 'navbar-center' : ''}`}
        activeKey={activeKey} role='navigation'
      >
        {/* IMAGEN >= 992 Scroll*/}
        <LogoComponent
          isDesktop={true}
          isScroll={true}
          isSticky={isSticky}
          secondaryImage={secondaryImage} />
        {/* MENU */}
        <MenuItems
          blogCategories={blogCategories}
          isDesktop={isDesktop}
          setShowOffCanvas={null} />
      </Nav>

      <div id="menu-right">
        <Nav className={`navbar-right ${isSticky ? 'scroll' : ''}`}>
          {/* BOTON LUPA + SCROLL */}
          <SearchBarMenu
            isSticky={isSticky}
            isScroll={true}
            showMiniSearchBar={showMiniSearchBar}
            setShowMiniSearchBar={setShowMiniSearchBar}
          />

          {/* CONEXION DESDE MENU DESKTOP*/}
          <MyAccount
            setShowOffCanvas={null}
            closeSession={closeSession}
            isSticky={isSticky}
            isDesktop={true} />
        </Nav>

        {/* BOTON PRODUCTOS >= 992 + SCROLL*/}
        <Link
          to={libraryPath('carrito')}
          aria-label={`Carrito de compras (${countItems} items)`}
          className={`header__button header__button--cart ml-4
                  ${countItems > 0 ? ' filled' : ''}
                  `}
          style={{ display: isSticky ? 'flex' : 'none' }}
        >
          <RiShoppingBagFill className="icon-md" />
          {countItems > 0 && (
            <animated.span style={counterAnimProps} className="cart-counter">
              {countItems}
            </animated.span>
          )}
        </Link>
      </div>
    </Navbar.Collapse>
  );
};

NavbarCollapse.propTypes = {
  isDesktop: PropTypes.bool,
  isSticky: PropTypes.bool,
  secondaryImage: PropTypes.bool,
  blogCategories: PropTypes.any,
  showMiniSearchBar: PropTypes.bool,
  counterAnimProps: PropTypes.any,
  closeSession: PropTypes.func,
  setShowMiniSearchBar: PropTypes.func,
  activeKey: PropTypes.string
};

export default NavbarCollapse;
